import axios from 'axios'
import {
    ConfigurationPersonnelNumberAssignmentCreateRequest,
    ConfigurationPersonnelNumberAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-number-assignment/configuration-personnel-number-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelNumberAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelNumberAssignmentCreateRequest): Promise<ConfigurationPersonnelNumberAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelNumberAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelNumberAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelNumberAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelNumberAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelNumberAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelNumberAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelNumberAssignments/${personnelNumberAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelNumberAssignmentService = new ConfigurationPersonnelNumberAssignmentService()
